module.exports = __webpack_public_path__ + "static/from-a-workplace-centric-to-a-worker-centric-world-546b660e39baecbed4da3641b67b77ec.png";